import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Emilus';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};



export const colorStyles = [
  { color: '#9467bd', backgroundColor: '#eae1f2', borderColor: '#9467bd' },
  { color: '#1f77b4', backgroundColor: '#dceefa', borderColor: '#1f77b4' },
  { color: '#ff7f0e', backgroundColor: '#ffe6d0', borderColor: '#ff7f0e' },
  { color: '#2ca02c', backgroundColor: '#d6f5d6', borderColor: '#2ca02c' },
  { color: '#d62728', backgroundColor: '#f9d6d5', borderColor: '#d62728' },
  { color: '#17becf', backgroundColor: '#d5f3f7', borderColor: '#17becf' },
  { color: '#bcbd22', backgroundColor: '#f7f6d5', borderColor: '#bcbd22' },
  { color: '#7f7f7f', backgroundColor: '#e0e0e0', borderColor: '#7f7f7f' },
  { color: '#8c564b', backgroundColor: '#f0e3df', borderColor: '#8c564b' },
  { color: '#e377c2', backgroundColor: '#fbe4f1', borderColor: '#e377c2' },
  { color: '#1a55ff', backgroundColor: '#dde5ff', borderColor: '#1a55ff' },
  { color: '#00b894', backgroundColor: '#d0f5eb', borderColor: '#00b894' },
  { color: '#fdcb6e', backgroundColor: '#fff3d9', borderColor: '#fdcb6e' },
  { color: '#6c5ce7', backgroundColor: '#e6e3fb', borderColor: '#6c5ce7' },
  { color: '#00cec9', backgroundColor: '#d1f5f5', borderColor: '#00cec9' },
  { color: '#e17055', backgroundColor: '#fce1db', borderColor: '#e17055' },
  { color: '#2d3436', backgroundColor: '#dcdcdc', borderColor: '#2d3436' },
  { color: '#fab1a0', backgroundColor: '#fff0ec', borderColor: '#fab1a0' },
  { color: '#ffeaa7', backgroundColor: '#fffbe4', borderColor: '#ffeaa7' },
  { color: '#a29bfe', backgroundColor: '#edeaff', borderColor: '#a29bfe' },
  { color: '#74b9ff', backgroundColor: '#e3f1ff', borderColor: '#74b9ff' },
  { color: '#55efc4', backgroundColor: '#dbfff3', borderColor: '#55efc4' },
  { color: '#81ecec', backgroundColor: '#e5fafa', borderColor: '#81ecec' },
  { color: '#dfe6e9', backgroundColor: '#f6f7f8', borderColor: '#dfe6e9' },
  { color: '#636e72', backgroundColor: '#e1e3e5', borderColor: '#636e72' },
  { color: '#fd79a8', backgroundColor: '#ffe6f1', borderColor: '#fd79a8' },
  { color: '#e84393', backgroundColor: '#ffd9eb', borderColor: '#e84393' },
  { color: '#0984e3', backgroundColor: '#dceeff', borderColor: '#0984e3' },
  { color: '#6ab04c', backgroundColor: '#e1f4d5', borderColor: '#6ab04c' },
  { color: '#f0932b', backgroundColor: '#ffe8d2', borderColor: '#f0932b' },
];